$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Lai veiktu pirkumu, Jums ir jāpiekrīt veikala Noteikumiem un Nosacījumiem.");
        return false;
      }
    });
  });